import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { CheckConfirmationIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

export const Summary = () => {
  const [{ value }] = useFormField({ name: 'confirmationPageType' })
  const label = value === 'internal'
    ? I18n.t('publisher.event_type_editor.sections.more_options.confirmation_page.helper_text')
    : I18n.t('publisher.event_types.confirmation_page.type.external')

  return (
    <BodyText color={colorTextSecondary} size="medium">
      <CheckConfirmationIcon size="standard" color={colorIconSecondary} spacingRight="8" />
      {label}
    </BodyText>
  )
}
